import * as React from 'react';

import { CheckboxField } from '@cian/components';

import { DropdownField, IDropdownValue } from '../../../components/dropdownField';

import { ESaleType } from '../../../../../../../json_query';
import { FOfferType } from '../../../../../../../utils/category';
import { InlineParam } from '../../../markup';

interface ISaleTypesProps {
  offerType: FOfferType;

  saleTypes: ESaleType[];
  onSaleTypesChange(value: ESaleType[]): void;

  mortgage: boolean;
  onMortgageChange(value: boolean): void;
}

const FLAT_NEW_SALE_TYPES: IDropdownValue[] = [
  { label: '214-Ф3', value: ESaleType.F3 },
  { label: 'Договор ЖСК', value: ESaleType.GSKContract },
  { label: 'Переуступка', value: ESaleType.Reassignment },
];

const FLAT_SALE_TYPES: IDropdownValue[] = [
  { label: 'Свободная', value: ESaleType.Free },
  { label: 'Альтернативная', value: ESaleType.Alternative },
];

/* istanbul ignore next */
export const SaleType: React.StatelessComponent<ISaleTypesProps> = props => {
  const getValue = () => {
    const { saleTypes } = props;
    const result = [];

    if (saleTypes && saleTypes.length) {
      result.push(...saleTypes);
    }

    return result;
  };

  return (
    <>
      <InlineParam>
        <DropdownField
          multiple
          placeholder="Неважно"
          value={getValue()}
          onValueChange={props.onSaleTypesChange}
          values={props.offerType === FOfferType.FlatNew ? FLAT_NEW_SALE_TYPES : FLAT_SALE_TYPES}
        />
      </InlineParam>

      <InlineParam>
        <CheckboxField label="Возможна ипотека" value={props.mortgage} onValueChange={props.onMortgageChange} />
      </InlineParam>
    </>
  );
};
